import {join} from '@esgillc/ui-kit/utils';
import {forwardRef} from 'react';
import styles from '../styles.module.less';
import {DivProps} from '../types';

export const Column = forwardRef<HTMLDivElement, DivProps>(({className, ...props}, ref) => {
	return <div className={join(styles.column, className)} {...props} ref={ref}/>;
});
